var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"branchLocations"}},[_c('br'),_c('div',{staticClass:"row contenedor"},[_c('GoogleMap',{staticStyle:{"width":"100%","height":"600px"},attrs:{"center":_vm.center,"zoom":5}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }